import type { CameraPadding } from '../domain/camera-plan';
import { routePadding } from '../map/camera-framing';

/** Preserve the original clear map row while extending its canvas beneath the plates. */
export function legacyPlateCameraPadding(root: HTMLElement, width: number, height: number): CameraPadding {
  const origin = root.getBoundingClientRect();
  const clear = root.querySelector<HTMLElement>('.legacy-map-clear-area')?.getBoundingClientRect();
  if (!clear || clear.width <= 0 || clear.height <= 0) return routePadding(width, height);
  const inner = routePadding(clear.width, clear.height);
  return { left: clear.left - origin.left + inner.left, right: width - (clear.right - origin.left) + inner.right,
    top: clear.top - origin.top + inner.top, bottom: height - (clear.bottom - origin.top) + inner.bottom };
}
